import { $createParagraphNode, $getRoot, $setSelection } from 'lexical';

export const clearWithoutFocusing = () => {
    const root = $getRoot();
    const paragraph = $createParagraphNode();
    root.clear();
    $setSelection(null);
    root.append(paragraph);
};
